import { Component, OnInit } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { CatalogInfoObject } from 'src/app/models/catalog/catalog-info-object.model';
import { CatalogItemObject } from 'src/app/models/catalog/catalog-item-object.model';
import { CatalogTreeCardObject } from 'src/app/models/catalog/catalog-tree-item-object.model';
import { CatalogService } from 'src/app/services/api/catalog/catalog.service';
import { NotificationLevel, NotificationsService } from 'src/app/services/api/notifications/notifications.service';
import { BreadcrumbsService } from 'src/app/services/utils/breadcrumbs.service';

@Component({
  selector: 'app-catalog-list',
  templateUrl: './catalog-list.component.html',
  styleUrls: ['./catalog-list.component.scss']
})
export class CatalogListComponent implements OnInit {

  items: Map<string, Array<CatalogItemObject>>;
  info: CatalogInfoObject;
  node: CatalogTreeCardObject;
  selectedNode: CatalogTreeCardObject;
  productsName: Array<string>;
  productId: string;
  searchText: string;

  constructor(private breadcrumbsService: BreadcrumbsService,
    private catalogService: CatalogService,
    private notificationsService: NotificationsService,
    private titleService: Title) { }

  ngOnInit() {
    if (this.titleService.getTitle().includes(" - ")) {
      this.titleService.setTitle(this.titleService.getTitle().split(" - ")[1]);
    }

    this.breadcrumbsService.sendBreadcrumbs(
      {
        breadcrumbs: [
          { title: 'Catálogo', url: 'provision/catalog' }
        ]
      });
    this.info = CatalogInfoObject.create();
    this.items = new Map<string, Array<CatalogItemObject>>();
    this.productsName = new Array<string>();
    this.selectedNode = CatalogTreeCardObject.create();
    this.node = CatalogTreeCardObject.create();
    this.load();
  }

  private toArray(items: IterableIterator<string>): Array<string> {
    const keys = new Array<string>();
    for (const key of items) {
      keys.push(key);
    }
    return keys;

  }

  onClickCard($event: any) {
    this.info = CatalogInfoObject.create();
    this.selectedNode = $event;
    this.loadDependencies();
  }

  loadDependencies() {
    this.catalogService.getItemInfo(this.selectedNode.id, this.getType(this.selectedNode)).subscribe(
      (info) => {
        this.info = info;
      },
      (error) => {
        this.notificationsService.showNotification(
          'Ha habido un problema al recuperar la informacion de las características y dependencias del catálogo',
          NotificationLevel.ERROR);
      })
  }

  loadTree(productId: string) {
    this.node = CatalogTreeCardObject.create();
    this.catalogService.getCatalogTree(productId).subscribe((data) => {
      this.node = data;
    },
      (error) => {
        this.notificationsService.showNotification(
          'Ha habido un problema al recuperar los productos del catálogo',
          NotificationLevel.ERROR);
      });
  }

  private getType(item: any): string {
    let type = 'PRODUCT';
    if (item.type !== undefined) {
      type = item.type;
    }
    return type;
  }


  private load() {
    this.items = new Map();
    this.productsName = new Array<string>();
    this.catalogService.getCatalog().subscribe(
      (data) => {
        this.items = data;
        this.productsName = this.toArray(data.keys());
      },
      (error) => {
        this.notificationsService.showNotification(
          'Ha habido un problema al recuperar los productos del catálogo',
          NotificationLevel.ERROR);
      }
    );
  }


  public afterExpand($event: any) {

    this.info = CatalogInfoObject.create();
    this.productId = $event.id;
    this.loadTree(this.productId);
    this.selectedNode = new CatalogTreeCardObject($event.id, $event.name, 'PRODUCT', $event.version, $event.dependencies, new Array());
    this.loadDependencies();
  }

  public afterCollapse() {
    this.info = CatalogInfoObject.create();
    this.node = CatalogTreeCardObject.create();
    this.selectedNode = CatalogTreeCardObject.create();
  }


}
